import {Component, OnInit, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {TemplateService} from '../../services/template.service';
import {CALENDAR_LOCALE} from '../../services/constant';
import {ApiService} from '../../services/api.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {SelectItem} from 'primeng/api';
import * as _ from 'lodash';
import {HttpParams} from '@angular/common/http';

@Component({
  selector: 'app-history-log',
  templateUrl: './history-log.component.html',
  styleUrls: ['./history-log.component.scss'],
  providers: [TemplateService]
})
export class HistoryLogComponent implements OnInit {

  startDate: Date = new Date(moment().format('YYYY') + '-01-01');
  endDate: Date = new Date(moment().format('YYYY') + '-12-30');
  maxDate: Date;
  minDate: Date;
  loading = false;
  calendarLocale = CALENDAR_LOCALE.TH;
  currentPage: 1;
  itemsPerPage: number;
  totalItems: number;
  errors = [];
  customercode: any;
  selectedCustomercode = null;
  selectedRdDocumentType: any;
  checkdate = null;
  rdDocumentType: any;
  historyLogType: any;
  selectedAction: any;
  defaultLabel = null;
  sortBy = null;
  sortMode = null;
  no_data = true;
  errorMsg = '';
  allDeliverycodeSelected = [];
  allDocumentType = [];
  deliverycode: any;
  documentType: any;
  notApprove: any;
  selectedHomeproGroup: SelectItem[];
  selectedDeliverycode: SelectItem[];
  tableData: any;
  allDeliverycode = true;
  allDocType = true;
  selectedValues = [];
  roles: any = [];
  searchRole: any;
  searchUsername: any;
  list: any = [];


  @ViewChild('content') content: any;
  @ViewChild('tt') table: any;

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private template: TemplateService,
    private translate: TranslateService
  ) {
    this.currentPage = 1;
    this.itemsPerPage = 40;
    this.totalItems = 0;
  }

  ngOnInit() {
    this.getHistoryLogType();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadGroups();
      this.userData();
      this.loadTexts();
    });
    this.loadGroups();
    this.userData();
    this.loadTexts();
    this.searchRole = null;
    this.searchUsername = null;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  getHistoryLogType() {
    this.apiService.getHistoryLogType().subscribe(
      (data) => {
        this.historyLogType = data.results;
      }
    );
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  loadTexts() {

    this.defaultLabel = this.translate.instant('COMMON.ALL');
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.defaultLabel = this.translate.instant('COMMON.ALL');
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
  }

  sentdate() {
    this.checkdate = 1;
  }

  optionChanged() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.searchData();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    if (!this.no_data) {
      this.table.reset();
    }
    this.searchData();
  }

  searchData(params?) {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }
    const data = {
      page: this.currentPage,
      page_size: this.itemsPerPage,
      user: this.searchUsername,
      role: this.searchRole,
      log_type: this.selectedAction || '',
      header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD')
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    if (this.currentPage === 1) {
      params = null;
    }
    // TODO wait api history-log
    this.apiService.getHistoryLog(data).subscribe(
      (result) => {
        this.loading = false;
        this.tableData = result.results;
        this.no_data = _.isEmpty(this.tableData);
        this.totalItems = result.count;

      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
      errorMsgList.push(this.translate.instant('FILTER.DELIVERY-CODE'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
      return;
    }

    // let dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
    // if (dayDiff > 60 && this.authService.isAccountant()) {
    //   this.errorMsg = "ไม่สามารถเลือกระยะเวลาเกิน 60 วัน";
    // }
  }

  clearData() {
    this.tableData = undefined;
    this.no_data = true;
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
    this.selectedCustomercode = null;
    this.selectedDeliverycode = null;
    this.selectedRdDocumentType = null;
    this.deliverycode = null;
    this.documentType = null;
    this.notApprove = false;
    this.allDocType = true;
    this.allDeliverycode = true;
    this.sortBy = null;
    this.sortMode = null;
    this.selectedValues = [];

    this.searchButtonClicked();
  }

  loadGroups() {
    this.roles = [{
      'label': this.translate.instant('COMMON.ALL'),
      'value': null
    }];
    this.apiService.getGroups().subscribe(
      (roles) => {
        _.forEach(roles, (role) => {
          this.roles.push({
            'label': role['name'],
            'value': role['id']
          });
        });
        this.roles = _.uniqBy(this.roles, 'label');
      },
      error => {
        console.log('error', error);
      }
    );
  }

  userData() {
    this.list = [];
    this.list = [{
      'label': this.translate.instant('COMMON.ALL'),
      'value': null
    }];
    this.loading = true;
    this.apiService.getUsers().subscribe(
      (res) => {
        _.forEach(res.results, (profile) => {
          this.list.push({
            'label': profile.username,
            'value': profile.id
          });
        });
        this.loading = false;
        this.list = _.uniqBy(this.list, 'label');
      },
      error => {
        this.loading = false;
      }
    );

  }

  clearSearch() {
    this.searchRole = null;
    this.searchUsername = null;
    this.search();
  }

  search() {
    this.currentPage = 1;
  }

  pageChanged() {
    let params = new HttpParams()
    params = params.append('page', this.currentPage.toString());
    this.searchData(params);
  }

}



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log.component.ts